export default __webpack_public_path__ + "fada7ea4a4370ec2c334a7d2198932a2.png";